import React, { useEffect, useMemo, useState, useRef } from 'react'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import 'bootstrap/dist/css/bootstrap.min.css'
import dayjs from 'dayjs';
import { NumericFormat } from 'react-number-format'
import {
  SearchOutlined,
  UploadOutlined,
  PrinterFilled,
  PlusOutlined,
  DownOutlined,
  FileExcelFilled
} from '@ant-design/icons'
import { FaTrash, FaAngleLeft, FaAngleRight } from 'react-icons/fa'
import { PlusCircleFilled } from '@ant-design/icons'
import {
  Input,
  Button,
  Modal,
  Tooltip,
  Dropdown,
  Select,
  InputNumber,
  Switch,
  Flex,
  Divider,
  Space,
  Form,
  Breadcrumb
} from 'antd'
import IconButton from '@mui/material/IconButton'
import Checkbox from '@mui/material/Checkbox'
import { StarFilled } from '@ant-design/icons'
import ExcelJS from 'exceljs'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import EditIcon from '@mui/icons-material/Edit'
import { FaEllipsisV } from 'react-icons/fa'
import { mainAxios } from '../../middleware/interceptor'
import { Logger } from '../../middleware/Logger'
import { toast } from 'react-toastify'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import Print from '../Print'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import AddIcon from '@mui/icons-material/Add';
import CustomTable from '../../CustomTable';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import PrintProductTemplate from '../PrintProductTemplate'

const customTheme = createTheme({
  palette: {
    primary: {
      main: '#19A73F'
    }
  }
});

const statusText = [
  [
    'Confirm activation of this item? Activated items will be shown on the count sheets. ',
    'Activate Item'
  ],
  [
    " Confirm deactivation of the item? Deactivated items won't be shown on the count sheets.",
    'Deactivate Item'
  ]
];

const initialPopupData = {
  itemName: '',
  category: '',
  unit: '',
  unitPrice: '',
  id: '',
  Multiple_Unit: '',
  subCategory: '',
  Product: '',
  subProduct: '',
  location: '',
  IsInMaster: false,
  purveyor: '',
  Inventory_date: '',
  pack: '',
  packSize: '',
  PackPrice: '',
  quantity: '',
  SubCategoryId: '',
  oldCategory: '',
  oldCat_Id: ''

};

const dropDownValue = [
  // { value: 'Bottle', label: 'Bottle' },
  // { value: 'Can', label: 'Can' },
  // { value: 'Case', label: 'Case' },
  // { value: 'Each', label: 'Each' },
  // { value: 'Gallon', label: 'Gallon' },
  // { value: 'Keg (1/2 BBL)', label: 'Keg (1/2 BBL)' },
  // { value: 'Keg (1/4 BBL)', label: 'Keg (1/4 BBL)' },
  // { value: 'Keg (1/6 BBL)', label: 'Keg (1/6 BBL)' },
  // { value: 'Kilogram', label: 'Kilogram' },
  // { value: 'Loaf', label: 'Loaf' },
  // { value: 'Ounce', label: 'Ounce' },
  // { value: 'Pound', label: 'Pound' },
  // { value: 'Quart', label: 'Quart' }
  { "label": "Bag", "value": "Bag" },
  { "label": "Batch", "value": "Batch" },
  { "label": "Bottle", "value": "Bottle" },
  { "label": "Box", "value": "Box" },
  { "label": "Bunch", "value": "Bunch" },
  { "label": "Bushel", "value": "Bushel" },
  { "label": "Can", "value": "Can" },
  { "label": "Case", "value": "Case" },
  { "label": "Container", "value": "Container" },
  { "label": "Count", "value": "Count" },
  { "label": "Crate", "value": "Crate" },
  { "label": "Cup", "value": "Cup" },
  { "label": "Dozen", "value": "Dozen" },
  { "label": "Each", "value": "Each" },
  { "label": "Flat", "value": "Flat" },
  { "label": "Fluid Ounce", "value": "Fluid Ounce" },
  { "label": "Gallon", "value": "Gallon" },
  { "label": "Gram", "value": "Gram" },
  { "label": "Jar", "value": "Jar" },
  { "label": "Keg (1/2BBL) 15.5GAL", "value": "Keg (1/2BBL) 15.5GAL" },
  { "label": "Keg (20L/5.28gal)", "value": "Keg (20L/5.28gal)" },
  { "label": "Keg (30L/7.92gal)", "value": "Keg (30L/7.92gal)" },
  { "label": "Keg (50L/13.2gal)", "value": "Keg (50L/13.2gal)" },
  { "label": "Keg (5L/1.32gal)", "value": "Keg (5L/1.32gal)" },
  { "label": "Keg (1/8BBL) 3.1GAL", "value": "Keg (1/8BBL) 3.1GAL" },
  { "label": "Keg (1/4BBL) 7.75GAL", "value": "Keg (1/4BBL) 7.75GAL" },
  { "label": "Keg (1/6BBL) 5.16GAL", "value": "Keg (1/6BBL) 5.16GAL" },
  { "label": 'Keg (1/2 BBL)', "value": 'Keg (1/2 BBL)' },
  { "label": "Kilogram", "value": "Kilogram" },
  { "label": "Liter", "value": "Liter" },
  { "label": "Loaf", "value": "Loaf" },
  { "label": "Milligram", "value": "Milligram" },
  { "label": "Milliliter", "value": "Milliliter" },
  { "label": "Other", "value": "Other" },
  { "label": "Ounce", "value": "Ounce" },
  { "label": "Pack", "value": "Pack" },
  { "label": "Package", "value": "Package" },
  { "label": "Pail", "value": "Pail" },
  { "label": "Pan", "value": "Pan" },
  { "label": "Pan (1/2)", "value": "Pan (1/2)" },
  { "label": "Pan (1/9)", "value": "Pan (1/9)" },
  { "label": "Pan (1/6)", "value": "Pan (1/6)" },
  { "label": "Pan (1/3)", "value": "Pan (1/3)" },
  { "label": "Piece", "value": "Piece" },
  { "label": "Pint", "value": "Pint" },
  { "label": "Portion", "value": "Portion" },
  { "label": "Pound", "value": "Pound" },
  { "label": "Quart", "value": "Quart" },
  { "label": "Serving", "value": "Serving" },
  { "label": "Sheet", "value": "Sheet" },
  { "label": "Sleeve", "value": "Sleeve" },
  { "label": "Slice", "value": "Slice" },
  { "label": "Tablespoon", "value": "Tablespoon" },
  { "label": "Teaspoon", "value": "Teaspoon" },
  { "label": "Tub", "value": "Tub" }
];

const Products = () => {
  const UserClaims = localStorage.getItem('UserClaims')
  const pdfRef = useRef();

  const [data, setData] = useState([])
  const [counter, setCounter] = useState(0)
  const [dynamoData, setDynamoData] = useState([])
  const [progressBar, setProgressBar] = useState(false)
  const [nodata, setNodata] = useState(false)
  const [editOrCreate, setEditOrCreate] = useState('Add New Product')
  const [categoryDropdown, setCategoryDropDown] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [newSubCategoryName, setNewSubCategoryName] = useState('')
  const [rowSelection, setRowSelection] = useState({})
  const [RestID, setRestId] = useState(localStorage.getItem('RestId'))
  const [Budget_Exist_Status, setBudget_Exist_Status] = useState(
    JSON.parse(UserClaims)?.Budget_Exist_Status
  )
  const [isTableview, setTableView] = useState(false)
  const [IsModalOpentwo, setIsModalOpentwo] = useState(false)
  const [IsModalOpenbudget, setIsModalOpenbudget] = useState(false)
  const [popupData, setPopupData] = useState(initialPopupData)
  const [backupPopupData, setBackupPopupData] = useState(initialPopupData)
  const [subCategoryRawData, setSubCategoryRawData] = useState([])
  const [rowFieldErrors, setRowFieldErrors] = useState({})
  const [details, setDetails] = useState({})
  const [catName, setCatName] = useState()
  const [CatId, setCatId] = useState()
  const [itemid, setItemId] = useState()
  const [changeOfAction, setChangeOfAction] = useState(true)
  const [statusItemData, setItemStatusData] = useState({
    restid: '',
    catId: '',
    catName: '',
    itemId: '',
    status: ''
  })
  const [backupsaveData, setBackupsaveData] = useState([])
  const [backupData, setBackupData] = useState([])
  const [UnitDropDown, setUnitDropDown] = useState(dropDownValue)
  const [addMasterSheetLoader, setAddMasterSheetLoader] = useState(false)
  const [stsText, setStsText] = useState('')
  const [isError, setIsError] = useState(false)
  const [isItemExist, setIsItemExist] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [isClicked, setIsClicked] = useState(false)
  const [searchedValue, setSearchedValue] = useState('')
  const [idForAction, setIdForAction] = useState()
  const [allowrow, setallowrow] = useState(false)

  //should be memoized or stable
  const [isModalOpencategory, setIsModalOpenCategory] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalOpendelete, setIsModalDelete] = useState(false)
  const [isModalOpenstatus, setIsModalOpenStatus] = useState(false)
  const [deleteItemData, setDeleteItemData] = useState({
    restid: '',
    catId: '',
    catName: '',
    itemId: ''
  })
  const [productAndSubProductList, SetProductAndSubProductList] = useState([])
  const [productList, SetProductList] = useState([])
  const [subProductList, SetSubProductList] = useState([])
  const [newProduct, setNewProduct] = useState('')
  const [newSubProduct, setNewSubProduct] = useState('')
  const [PdfData, setPdfData] = useState([]);
  const [data1, setData1] = useState([{}]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 15, //customize the default page size
  });

  const isValidNumber = (value) => {
    return (!isNaN(value) && isFinite(value)) ? true : false;
  };

  const PopuponChange = (key, value) => {
    if (key === 'category') {
      if (subCategoryRawData.length > 0) {
        const subcat = subCategoryRawData.filter(
          u =>
            u.CatId.toString() === value.split('~')[1].toString()
          // && u.CatName.toString().trim() === value.split('~')[0].toString().trim()
        )

        if (subcat.length > 0) {
          const cat = subcat[0].SubCategories.map(x => ({
            label: x.SubCatName,
            value: `${x.SubCatName}~${x.SubCategoryId}`
          }))
          setSubCategories(cat);
          popupData.subCategory = '';
          popupData.SubCategoryId = '';
        } else {
          setSubCategories([])
          popupData.subCategory = '';
        }
      } else {
        setSubCategories([])
        popupData.subCategory = '';
      }
    }

    if (productAndSubProductList.length > 0) {
      if (key === 'category') {
        let productlist = productAndSubProductList.find(
          a => a.CatId.toString() === value.split('~')[1].toString()
        );
        popupData.Product = '';
        popupData.subProduct = '';
        SetProductList(productlist?.Products || [])
      } else if (key === 'Product') {
        // if (productList.length > 0) {
        let subProduct = productList.find(
          a => a.ProductId?.toString() === value?.split('~')[1].toString()
        );
        popupData.subProduct = '';
        SetSubProductList(subProduct?.SubProducts || [])
        // } else {
        // popupData.subProduct = '';
        // }
      }
    } else {
      SetProductList([]);
      SetSubProductList([]);
    }


    if (value !== null) {
      if (key === 'unitPrice') {
        let temp = { ...popupData };
        temp[key] = value;
        temp['PackPrice'] = isValidNumber(parseFloat(value ?? 0) / parseFloat(popupData.pack ?? 0))
          ? (parseFloat(value ?? 0) / parseFloat(popupData.pack ?? 0)).toFixed(2)
          : 0;

        setPopupData(temp);
      } else if (key === 'pack') {
        let temp = { ...popupData };
        temp[key] = value;
        temp['PackPrice'] = isValidNumber(parseFloat(popupData.unitPrice ?? 0) / parseFloat(value ?? 0))
          ? (parseFloat(popupData.unitPrice ?? 0) / parseFloat(value ?? 0)).toFixed(2)
          : 0;

        setPopupData(temp);
      } else if (key === 'subCategory') {
        let temp = { ...popupData };
        temp[key] = value;
        temp['SubCategoryId'] = value?.split('~')[1] ?? '';

        setPopupData(temp);
      } else {
        let temp = { ...popupData }
        temp[key] = value
        setPopupData(temp)

        const initial = data1.map((item, index) => {
          if (index == 0 && key == 'unit') {
            return { ...item, Name: value }
          } else if (index == 0 && key == 'unitPrice') {
            return { ...item, Price: value }
          } else {
            return item
          }
        })

        setData1(initial)
      }
    }

    if (key === 'unit') {
      setUnitDropDown(dropDownValue.filter(option => option.value !== value))
    }
  }

  const formatUnitPrice = value => {
    return value !== null && !isNaN(+value)
      ? setPopupData({ ...popupData, unitPrice: parseFloat(value).toFixed(2) })
      : setPopupData({ ...popupData, unitPrice: parseFloat(0).toFixed(2) })
  }

  const formatPackPrice = value => {
    return value !== null && !isNaN(+value)
      ? setPopupData({ ...popupData, PackPrice: parseFloat(value).toFixed(2) })
      : setPopupData({ ...popupData, PackPrice: parseFloat(0).toFixed(2) })
  }

  const formatMultipleUnitPrice = (value, index) => {
    const newData1 = data1.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          Price:
            value !== null && !isNaN(+value)
              ? parseFloat(value).toFixed(2)
              : parseFloat(0).toFixed(2)
        }
      } else {
        return item
      }
    })

    setData1(newData1)
  }

  const handleKeyDown = e => {
    // Allow only numbers (0-9) and allow 'Backspace', 'Delete', '.' and arrow keys
    if (
      e.key.match(/[^0-9]/) &&
      e.key !== 'Backspace' &&
      e.key !== 'Delete' &&
      e.key !== 'ArrowUp' &&
      e.key !== 'ArrowDown' &&
      e.key !== 'ArrowLeft' &&
      e.key !== 'ArrowRight' &&
      e.key !== '.'
    ) {
      e.preventDefault()
    }
  }

  const editFunction = () => {
    console.log(popupData, 'popupData');

    var pattern = /[^a-zA-Z0-9\s]/g
    const isItemNameExists = backupData.filter(
      item =>
        item?.category?.toLocaleLowerCase() ===
        popupData?.category?.split('~')[0]?.toLocaleLowerCase() &&
        item?.item?.toLocaleLowerCase()?.trim() ===
        popupData?.itemName?.toLocaleLowerCase()?.replace(pattern, '').trim()
    )

    const isValid = isItemNameExists.filter(x => x.id !== popupData.id).length
    const multi = data1.filter((item, index) => index !== 0)
    const checkAllFields =
      popupData?.itemName.toString().trim()?.length > 0 &&
      popupData?.unit?.length > 0 &&
      popupData?.unitPrice?.toLocaleString()?.length > 0 &&
      popupData?.category?.trim()?.length > 0 &&
      popupData?.subCategory?.trim()?.length > 0 &&
      popupData?.Product?.trim()?.length > 0 &&
      // popupData?.pack?.trim()?.length > 0 &&
      // popupData?.packSize?.trim()?.length > 0 &&
      // popupData?.quantity?.trim()?.length > 0 &&
      // popupData?.PackPrice?.trim()?.length > 0 &&
      popupData?.subProduct?.trim()?.length > 0;

    if (checkAllFields) {
      if (!isValid) {
        setIsError(false)
        setIsItemExist(false)
        // setIsClicked(true)
        const payData = {
          // Quantity: data1[0].Quantity,
          restid: RestID,
          catId: popupData.category.split('~')[1],
          catName: popupData.category.split('~')[0],
          Product: popupData.Product.split('~')[0] || "",
          SubProduct: popupData.subProduct.split('~')[0] || "",
          ProductId: popupData.Product.split('~')[1] || "",
          ProductId: popupData.Product.split('~')[1] || "",
          subProductId: popupData.subProduct.split('~')[1] || "",
          location: popupData.location,
          itemName: popupData.itemName.toString().trim(),
          itemUnit: popupData.unit ? popupData.unit : null,
          amount: parseFloat(popupData?.unitPrice).toFixed(2),
          itemId: popupData.id,
          Multiple_Unit: multi,
          subCatName: popupData?.subCategory?.split('~')[0] ? popupData.subCategory.split('~')[0] : '',
          SubCategoryId: popupData?.SubCategoryId ? popupData?.SubCategoryId : '',
          status: popupData?.IsInMaster === true ? '1' : '0',
          purveyor: popupData?.purveyor || "",
          Inventory_date: popupData?.Inventory_date || "",
          Pack: !!parseInt(popupData?.pack) ? parseInt(popupData?.pack) : 0,
          PackSize: popupData?.packSize || "",
          PackPrice: popupData?.PackPrice || 0,
          oldcatId: popupData?.oldCat_Id,
          oldcatName: popupData?.oldCategory,
          // Quantity: popupData?.quantity || "",
        };
        mainAxios
          .post('/api/Inventory/updateBaseItem', payData)
          .then(res => {
            if (res.data?.status.toString() === '1') {
              getSubCategories()
              toast.success('Product Updated Successfully.')
              getData()
              let Details = {
                oldItem: backupPopupData,
                EditedItemId: popupData.id.toString().trim(),
                EditedItem: payData
              }
              Logger(RestID, 'Product Edited', Details, '')
            } else {
              toast.error('Failed to Update Item.')
            }
            setIsModalOpen(false)
            setIsClicked(false)
          })
          .catch(() => {
            // toast.error('Failed to Update Item.')
            setIsModalOpen(false)
            setIsClicked(false)
          })
      } else {
        setIsItemExist(true)
        setIsError(true)
      }
    } else {
      setIsError(true);
    }
  }

  const handleCancelprod = () => {
    setIsModalOpentwo(false)
  }

  const handleOkprod = () => {
    setIsModalOpentwo(false)
  }

  const createFunction = () => {
    var pattern = /[^a-zA-Z0-9\s]+|\s+/g
    const multi = data1.filter((item, index) => index !== 0)
    const checkAllFields =
      popupData?.itemName.toString().trim()?.length > 0 &&
      popupData?.unit?.length > 0 &&
      popupData?.unitPrice?.toLocaleString()?.length > 0 &&
      popupData?.category?.length > 0 &&
      popupData?.subCategory?.length > 0 &&
      popupData?.Product?.length > 0 &&
      // popupData?.pack?.trim()?.length > 0 &&
      // popupData?.packSize?.trim()?.length > 0 &&
      // popupData?.quantity?.trim()?.length > 0 &&
      // popupData?.PackPrice?.trim()?.length > 0 &&
      popupData?.subProduct?.length > 0;

    let isItemNameExists
    if (popupData.subCategory) {
      isItemNameExists = backupData.filter(
        item =>
          item?.category?.toLocaleLowerCase() ===
          popupData?.category?.split('~')[0]?.toLocaleLowerCase() &&
          item?.subCategory?.toLocaleLowerCase() ===
          popupData?.subCategory?.toLocaleLowerCase() &&
          item?.item?.toLocaleLowerCase()?.replace(pattern, '').trim() ===
          popupData?.itemName?.toLocaleLowerCase().replace(pattern, '').trim()
      )?.length
    } else {
      isItemNameExists = backupData.filter(
        item =>
          item?.category?.toLocaleLowerCase() ===
          popupData?.category?.split('~')[0]?.toLocaleLowerCase() &&
          item?.item?.toLocaleLowerCase()?.replace(pattern, '').trim() ===
          popupData?.itemName?.toLocaleLowerCase().replace(pattern, '').trim()
      )?.length
    }

    if (checkAllFields) {
      if (isItemNameExists === 0) {
        setIsError(false)
        setIsItemExist(false)
        // setIsClicked(true)
        const payData = {
          restid: RestID,
          catId: popupData.category.split('~')[1],
          catName: popupData.category.split('~')[0],
          Product: popupData.Product.split('~')[0],
          SubProduct: popupData.subProduct.split('~')[0],
          ProductId: popupData.Product.split('~')[1],
          subProductId: popupData.subProduct.split('~')[1],
          location: popupData.location,
          itemName: popupData.itemName,
          itemUnit: popupData.unit,
          amount: +popupData.unitPrice,
          Multiple_Unit: multi,
          subCatName: popupData.subCategory.split('~')[0] ? popupData.subCategory.split('~')[0] : '',
          SubCategoryId: popupData.subCategory.split('~')[1] ? popupData.subCategory.split('~')[1] : '',
          status: popupData?.IsInMaster === true ? '1' : '0',
          Pack: !!parseInt(popupData?.pack) ? parseInt(popupData?.pack) : 0,
          PackSize: popupData?.packSize || "",
          PackPrice: popupData?.PackPrice || 0,
          // Quantity: popupData?.quantity || "",
        }
        mainAxios
          .post('/api/Inventory/addBaseItem', payData)
          .then(res => {
            if (res.data?.status.toString() === '1') {
              toast.success('Product Added Successfully')
              getSubCategories()
              let Details = {
                CreatedItem: popupData.itemName.toString().trim(),
                Payload: payData
              }
              Logger(RestID, 'Product Created', Details, '')
              getData()
              setIsModalOpen(false)
              setallowrow(false)
            } else {
              toast.error('Failed to Create Item.')
            }
            setIsClicked(false)
            setIsModalOpen(false)
          })
          .catch(() => {
            toast.error('Failed to Create Item.')
            setIsModalOpen(false)
            setIsClicked(false)
          })
      } else {
        setIsItemExist(true)
        setIsError(true)
      }
    } else {
      setIsError(true)
    }
  }

  const formatValue = (value) => {
    return value === null || value === undefined || value === '' ? '-' : value
  }

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

  const handleExcelDownload = () => {
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('Products')

    const headerRow = worksheet.addRow([
      'Category',
      'Sub Category',
      'Product',
      'Common Name',
      'Item',
      // 'Qty',
      'Unit',
      'Price / Unit',
      'Pack',
      'Size / Pack',
      'Price / Pack',
      'Recently Purchase',
      'Location'
    ])
    headerRow.font = { bold: true }
    data.forEach(item => {
      worksheet.addRow([
        formatValue(item.category),
        formatValue(item.subCategory),
        formatValue(item.ProductName),
        formatValue(item.SubProductName),
        formatValue(item.item),
        // formatValue(item.Quantity),
        formatValue(item.unit),
        item.unitPrice === null || item.unitPrice === undefined || item.unitPrice === ''
          ? '-'
          : currencyFormatter.format(item.unitPrice),
        formatValue(item?.Pack),
        formatValue(item?.PackSize),
        !!item?.PackPrice ? currencyFormatter.format(item?.PackPrice) : '-',
        formatValue(item?.Inventory_date ? dayjs(item?.Inventory_date).format('MM/DD/YYYY') : ''),
        formatValue(item.location),
      ])
    })

    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Products.xlsx'
      link.click()
    })
  }

  const items = [
    {
      key: '1',
      label: 'Excel',
      disabled: isLoading || data.length === 0,
      onClick: (() => {
        if (Budget_Exist_Status == 0) {
          setIsModalOpenbudget(true)
        } else {
          handleExcelDownload()
        }
      })
    },
    {
      key: '2',
      label: 'Print PDF',
      disabled: isLoading || data.length === 0,
      onClick: (Budget_Exist_Status == 0
        ? () => setIsModalOpenbudget(true)
        : () => pdfRef.current.handlePrint()
      )
    }
  ]

  const showCategorypopup = () => {
    setIsModalOpenCategory(true)
  }

  const handleOkcategory = () => {
    setIsModalOpenCategory(false)
  }

  const handleCancelcategory = () => {
    setIsModalOpenCategory(false)
  }

  const showmodalstatus = (row, e) => {
    setItemStatusData({
      restid: RestID,
      catId: row.catId,
      catName: row.category,
      itemId: row.id,
      status: e ? 1 : 0,
      itemName: row.item
    })
    setStsText(statusText[parseInt(row.Status)])

    setIsModalOpenStatus(true)
  }

  const handleOkstatus = () => {
    mainAxios
      .post('/api/Inventory/updateItemStatus', statusItemData)
      .then(res => {
        if (res.data?.status.toString() === '1') {
          if (statusItemData.status == 1) {
            toast.success('Item Added to Master Countsheet successfully.')
          } else {
            toast.success('Item Removed from Master Countsheet successfully.')
          }

          let Details = {
            ItemId: statusItemData.itemId.toString(),
            Payload: statusItemData
          }
          Logger(RestID, 'Product Status Changed', Details, '')

          setData(pre =>
            pre.map(y => {
              if (y.id.toString() === statusItemData.itemId.toString()) {
                return { ...y, Status: statusItemData['status'] }
              } else {
                return { ...y }
              }
            })
          )
          // getData()
          setItemStatusData({
            restid: '',
            catId: '',
            catName: '',
            itemId: '',
            status: ''
          })
        } else {
          toast.error('Status Changes Failed')
          setItemStatusData({
            restid: '',
            catId: '',
            catName: '',
            itemId: '',
            status: ''
          })
        }
      })
      .catch(err => {
        setItemStatusData({
          restid: '',
          catId: '',
          catName: '',
          itemId: '',
          status: ''
        })
        if (statusItemData.status == 1) {
          toast.error('Failed to Add Item to Master Countsheet.')
        } else {
          toast.error('Failed to Remove Item from Master Countsheet.')
        }
      })
    setIsModalOpenStatus(false)
  }

  const handleCancelstatus = () => {
    setIsModalOpenStatus(false)
    setItemStatusData({
      restid: '',
      catId: '',
      catName: '',
      itemId: '',
      status: ''
    })
  }

  const showmodaldelete = row => {
    setDeleteItemData({
      restid: RestID,
      catId: row.catId,
      catName: row.category,
      itemId: row.id,
      itemName: row.item
    })
    setIsModalDelete(true)
  }

  const handleOkprodbudget = () => {
    setIsModalOpenbudget(false)
  }

  const handleOkdelete = () => {
    mainAxios
      .post('/api/Inventory/deleteBaseItem', deleteItemData)
      .then(res => {
        if (res.data?.status?.toString() === '1') {
          toast.success('Item deleted successfully')
          let Details = {
            ItemId: deleteItemData.itemId.toString(),
            Payload: deleteItemData
          }
          Logger(RestID, 'Product Deleted', Details, '')
          setDeleteItemData({
            restid: '',
            catId: '',
            catName: '',
            itemId: ''
          })
          getData()
          delete rowSelection[
            `${deleteItemData.itemId}~${deleteItemData.catName}~${deleteItemData.catId}`
          ]
          setIsModalDelete(false)
        } else {
          setDeleteItemData({
            restid: '',
            catId: '',
            catName: '',
            itemId: ''
          })
          toast.warn('item delete failed')
          setIsModalDelete(false)
        }
      })
      .catch(err => {
        setDeleteItemData({
          restid: '',
          catId: '',
          catName: '',
          itemId: ''
        })
        console.log(err)
        setIsModalDelete(false)
      })
  }

  const handleCanceldelete = () => {
    setDeleteItemData({
      restid: '',
      catId: '',
      catName: '',
      itemId: ''
    })
    setIsModalDelete(false)
  }

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleOk = () => {
    if (editOrCreate === 'Add New Product') {
      createFunction()
    } else if (editOrCreate === 'Edit Product') {
      editFunction()
    }
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setIsError(false)
    setIsItemExist(false)
    setallowrow(false)
    setUnitDropDown(dropDownValue)
    setBackupsaveData([])
  }

  const columns = useMemo(() => [
    {
      accessorKey: 'category',
      header: 'Category',
      size: 130,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'left'
      }
    },
    {
      accessorKey: 'subCategory',
      header: 'Sub Category',
      size: 160,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'left'
      }
    },
    {
      accessorKey: 'ProductName',
      header: 'Product',
      size: 160,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'left'
      }
    },
    {
      accessorKey: 'SubProductName',
      header: 'Common Name',
      size: 160,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'left'
      }
    },
    {
      accessorKey: 'item',
      header: 'Item',
      size: 333,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'left'
      },
      Cell: ({ row }) => {
        if (row.original.CreatedAt !== '') {
          const createddate = dayjs(row.original.CreatedAt)

          const sevenDaysLater = createddate.add(7, 'day')
          if (dayjs().isBefore(sevenDaysLater)) {
            return (
              <>
                <span>{row.original.item}</span> &nbsp; &nbsp;
                <StarFilled style={{ color: '#ffd700' }} />
              </>
            )
          } else {
            return (
              <>
                <span>{row.original.item}</span>
              </>
            )
          }
        } else {
          return (
            <>
              <span>{row.original.item}</span>
            </>
          )
        }
      }
    },
    // {
    //   accessorKey: 'Quantity',
    //   header: 'Qty',
    //   size: 60,
    //   muiTableHeadCellProps: {
    //     align: 'left'
    //   },
    //   muiTableBodyCellProps: {
    //     align: 'left'
    //   },
    // },
    {
      accessorKey: 'unit', //normal accessorKey
      header: 'Unit',
      size: 100,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'left'
      },
      Cell: ({ row }) => {
        return (
          <>
            {row?.original.category != '' ? (
              <span>{row?.original.unit}</span>
            ) : (
              <span>
                {row?.original.multiName}({row.original.multiQnty}&nbsp;
                {row.original.unit})
              </span>
            )}
          </>
        )
      }
    },
    {
      accessorKey: 'unitPrice',
      header: 'Price / Unit',
      size: 130,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'right'
      },
      sortDescFirst: true,
      Cell: ({ row }) => {
        return (
          <>
            {!!row?.original.unitPrice ? (
              currencyFormatter.format(row?.original.unitPrice)
            ) : (
              <div></div>
            )}
          </>
        )
      }
    },
    {
      accessorKey: 'Pack',
      header: 'Pack',
      size: 100,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'left'
      },
    },
    {
      accessorKey: 'PackSize',
      header: 'Size / Pack',
      size: 100,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'left'
      },
    },
    {
      accessorKey: 'PackPrice',
      header: 'Price / Pack',
      size: 130,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'right'
      },
      sortDescFirst: true,
      Cell: ({ row }) => {
        return (
          <>
            {!!row?.original.PackPrice ? (
              currencyFormatter.format(row?.original.PackPrice)
            ) : (
              <div></div>
            )}
          </>
        )
      }
    },
    {
      accessorKey: 'Inventory_date',
      header: 'Recently Purchased',
      size: 100,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'left'
      }
    },
    {
      accessorKey: 'location',
      header: 'Location',
      size: 100,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'left'
      }
    },
    // {
    //   accessorKey: 'Status',
    //   header: 'MasterSheet',
    //   size: 100,
    //   muiTableHeadCellProps: {
    //     align: 'left'
    //   },
    //   muiTableBodyCellProps: {
    //     align: 'center'
    //   },
    //   enableSorting: false,
    //   filterVariant: 'multi-select',
    //   filterSelectOptions: [
    //     { label: 'Active', value: 1 },
    //     { label: 'De-Active', value: 0 }
    //   ],
    //   Cell: ({ row }) => {
    //     return (
    //       <>
    //         {row?.original.category != '' ? (
    //           <Switch
    //             checked={
    //               row.original.Status?.toString() === '1' ? true : false
    //             }
    //             onClick={e => showmodalstatus(row.original, e)}
    //             size='small'
    //           />
    //         ) : (
    //           <div></div>
    //         )}
    //       </>
    //     )
    //   }
    // },
    {
      accessorKey: 'action',
      header: 'Action',
      size: 50,
      muiTableHeadCellProps: {
        align: 'left'
      },
      muiTableBodyCellProps: {
        align: 'center'
      },
      enableColumnFilter: false,
      enableSorting: false,
      enableColumnActions: false,
      Cell: ({ row }) => {
        return (
          <>
            {row?.original.category != '' ? (
              <div
                style={{
                  display: 'flex',
                  gap: '15px',
                  justifyContent: 'center'
                }}
              >
                <Tooltip title='Edit'>
                  <EditIcon
                    onClick={() => {
                      editItem(row.original)
                    }}
                    style={{
                      color: '#6A8AB9',
                      cursor: 'pointer',
                      fontSize: '20px'
                    }}
                  />
                </Tooltip>

                <Tooltip title='Delete'>
                  <FaTrash
                    onClick={() => showmodaldelete(row.original)}
                    style={{ color: '#F86764', cursor: 'pointer' }}
                  />
                </Tooltip>
              </div>
            ) : (
              <div></div>
            )}
          </>
        )
      }
    }
  ], [subCategoryRawData, rowSelection]);

  const columns1 = useMemo(
    () => [
      {
        accessorKey: 'UnitName',
        header: 'Name',
        size: 100,
        muiTableHeadCellProps: {
          align: 'left'
        },
        muiTableBodyCellProps: {
          align: 'left'
        },
        Cell: ({ row }) => {
          return (
            <>
              {row.original.status1 == 'label' ? (
                <span>{row.original.UnitName}</span>
              ) : (
                <Input
                  required
                  value={row.original.UnitName}
                  style={{ textAlign: 'left' }}
                  onChange={event =>
                    handleRowChange(row.index, 'UnitName', event.target.value)
                  }
                />
              )}
            </>
          )
        }
      },
      // {
      //   accessorKey: 'Quantity',
      //   header: 'Qty',
      //   size: 100,
      //   muiTableHeadCellProps: {
      //     align: 'left'
      //   },
      //   muiTableBodyCellProps: {
      //     align: 'left'
      //   },
      //   Cell: ({ row, index }) => {
      //     return (
      //       <>
      //         {row.original.status1 == 'label' ? (
      //           <span>{row.original.Quantity}</span>
      //         ) : (
      //           <>
      //             <Input
      //               style={{ textAlign: 'left' }}
      //               value={row.original.Quantity}
      //               onChange={event =>
      //                 handleRowChange(row.index, 'Quantity', event.target.value)
      //               }
      //             />
      //             {rowFieldErrors[row.index]?.Quantity && (
      //               <div style={{ color: 'red' }}>
      //                 {rowFieldErrors[row.index]?.Quantity}
      //               </div>
      //             )}
      //           </>
      //         )}
      //       </>
      //     )
      //   }
      // },
      {
        accessorKey: 'Name',
        header: 'Unit',
        size: 100,
        muiTableHeadCellProps: {
          align: 'left'
        },
        muiTableBodyCellProps: {
          align: 'left'
        },
        Cell: ({ row }) => {
          return (
            <>
              {row.original.status1 == 'label' ? (
                <span>{row.original.Name}</span>
              ) : (
                <>
                  <Select
                    className='ant-select'
                    value={row.original.Name}
                    placeholder='Select'
                    onChange={value =>
                      handleRowChange(row.index, 'Name', value)
                    }
                    style={{ textAlign: 'left', minWidth: '80px' }}
                    dropdownStyle={{ zIndex: 9999 }}
                    options={UnitDropDown}
                    disabled={row.index == 0}
                  >
                    {/*
            {unitOptions.map((option) => (
              <Option key={option} value={option}>
                {option}
              </Option>
            ))} */}
                  </Select>

                  {rowFieldErrors[row.index]?.Name && (
                    <div style={{ color: 'red' }}>
                      {rowFieldErrors[row.index]?.Name}
                    </div>
                  )}
                </>
              )}
            </>
          )
        }
      },
      {
        accessorKey: 'Price',
        header: 'Price',
        size: 100,
        muiTableHeadCellProps: {
          align: 'left'
        },
        muiTableBodyCellProps: {
          align: 'left'
        },
        Cell: ({ row }) => {
          return (
            <>
              {row.original.status1 == 'label' ? (
                <span>{row.original.Price}</span>
              ) : (
                <>
                  <Input
                    style={{ textAlign: 'left' }}
                    value={row?.original?.Price?.toString().replace('$', '')}
                    disabled={row.index == 0}
                    onChange={event =>
                      handleRowChange(row.index, 'Price', event.target.value)
                    }
                    onBlur={e => {
                      e.target.value?.length === 0 &&
                        row.original.Price?.toString().replace('$', '')
                          ?.length === 0
                        ? formatMultipleUnitPrice('0', row.index)
                        : formatMultipleUnitPrice(
                          row?.original?.Price?.toString().replace('$', ''),
                          row.index
                        )
                    }}
                  />
                  {rowFieldErrors[row.index]?.Price && (
                    <div style={{ color: 'red' }}>
                      {rowFieldErrors[row.index]?.Price}
                    </div>
                  )}
                </>
              )}
            </>
          )
        }
      },

      {
        // accessorKey: 'action',
        header: 'Action',
        size: 100,
        muiTableHeadCellProps: {
          align: 'left'
        },
        muiTableBodyCellProps: {
          align: 'left'
        },
        enableColumnFilter: false,
        Cell: ({ row }) => {
          return (
            <>
              {row.original.status1 == 'label' ? (
                <div
                  style={{
                    display: 'flex',
                    gap: '15px',
                    justifyContent: 'left'
                  }}
                >
                  <EditIcon
                    style={{
                      color: '#6A8AB9',
                      cursor: 'pointer',
                      fontSize: '20px'
                    }}
                    onClick={() => editIcon(row.index, row.original)}
                  />

                  <DeleteOutlineOutlinedIcon
                    onClick={() => Delete(row.original, row.index)}
                    style={{
                      color: '#F86764',
                      cursor: 'pointer',
                      fontSize: '20px'
                    }}
                  />
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    gap: '15px',
                    justifyContent: 'left'
                  }}
                >
                  {row.id == 0 ? (
                    ''
                  ) : (
                    <CheckCircleIcon
                      style={{
                        color: '#6A8AB9',
                        cursor: 'pointer',
                        fontSize: '20px'
                      }}
                      onClick={event =>
                        saveMultcheckDataValueipleUnits(row.index, row.original)
                      }
                    />
                  )}

                  {row.id == 0 ? (
                    ''
                  ) : (
                    <CancelIcon
                      style={{
                        color: '#F86764',
                        cursor: 'pointer',
                        fontSize: '20px'
                      }}
                      disabled={(row.original.id = 1)}
                      onClick={() => cancelIcon(row.index)}
                    />
                  )}
                </div>
              )}
            </>
          )
        }
      }
    ],
    [data1, changeOfAction, UnitDropDown, rowFieldErrors]
  );

  const addnewRow = () => {
    setChangeOfAction(true)
    setallowrow(true)

    //setCounter((prevCounter) => prevCounter + 1);
    setData1(prevData => [
      ...prevData,
      {
        id1: counter, // Adding a UUID to the object
        Name: '',
        Price: '',
        Quantity: '',
        status1: 'edit',
        status2: ''
      }
    ])
    //alert(changeOfAction)
    setCounter(prevCounter => prevCounter + 1)
  };

  const cancelIcon = e => {
    setChangeOfAction(false)

    const needata = data1.map((item, index) => {
      if (index == e && item.status2 == '') {
        return { ...item, Name: '', Price: '', Quantity: '', status1: 'label' }
      } else if (index == e && item.status2 == 'saved') {
        const final = backupsaveData.filter(item => item.index == e)

        return { ...final[0], status1: 'label' }
      } else {
        return item
      }
    })

    setData1(needata)
    // alert(changeOfAction)
  };

  const editIcon = (e, row) => {
    const needata = data1.map((item, index) => {
      if (index == e) {
        return { ...item, status1: 'edit', index: index }
      } else {
        return item
      }
    })
    const back = needata[e]

    const result = backupsaveData?.filter(item => item.index == e)
    if (result?.length > 0) {
      setBackupsaveData(prev => {
        const newArray = [...prev]
        newArray.map((item, index) => {
          if (item.index === e) {
            newArray[index] = {
              ...item,
              Name: row.Name,
              Price: row.Price,
              Quantity: row.Quantity,
              index: row.index,
              status1: row.status1,
              status2: row.status2
            }
          }
          return item // return the item for other elements in the array
        })
        return newArray // return the updated array
      })
    } else {
      setBackupsaveData(prev => [...prev, back])
    }
    setData1(needata)
    setChangeOfAction(true)
    setIdForAction(e)
    //alert(changeOfAction)
  }

  const Delete = (e, index) => {
    const payData = {
      restid: parseInt(RestID),
      catId: CatId,
      catName: catName,
      itemId: itemid,
      UnitId: e.UnitId
    }

    mainAxios
      .post('/api/Inventory/deleteUnitFromMultiUnits', payData)
      .then(res => {
        if (res.data.status === '1') {
          getData()
          toast.success(res.data.message)
        }

        // Add the respective option to the UnitDropDown array
        setUnitDropDown(prevOptions => [
          ...prevOptions,
          { value: e.Name, label: e.Name }
        ])
        setData1(prevData => {
          const temp = [...prevData]
          temp?.splice(index, 1)
          return temp
        })
      })
      .catch(() => { })
  }

  const handleRowChange = (t, event, value) => {
    if (event === 'Name') {
      setUnitDropDown(prevOptions =>
        prevOptions.filter(option => option.value !== value)
      )
    }
    setData1(prevData => {
      return prevData.map((row, index) => {
        if (index === t) {
          let updatedRow = { ...row, [event]: value }

          // Check if the event is "Quantity" and update Price accordingly
          if (event === 'Quantity') {
            updatedRow.Price = value * popupData.unitPrice
          }

          return updatedRow
        } else {
          return row
        }
      })
    })
  }

  const saveMultcheckDataValueipleUnits = (id, dat) => {
    const errors = {}
    data1.forEach((item, index) => {
      if (index === id) {
        if (!item.Quantity) {
          errors.Quantity = 'Quantity is required'
        }

        if (!item.Name) {
          errors.Name = 'Unit is required'
        }

        if (!item.Price) {
          errors.Price = 'Price is required'
        }
      }
    })

    // Set the row field errors state
    setRowFieldErrors({ ...rowFieldErrors, [id]: errors })

    // Check if there are any errors
    const hasErrors = Object.keys(errors).length > 0

    // If there are errors, return early
    if (hasErrors) {
      return
    }

    // Clear previous row field errors
    setRowFieldErrors({})
    const isAllFieldsFilled = data1.every(
      (item, index) =>
        index === id || (item.Quantity && item.Name && item.Price)
    )

    // Set status1 based on whether all fields are filled
    const needata = data1.map((item, index) => {
      if (index === id) {
        return {
          ...item,
          status1: !hasErrors ? 'label' : 'edit',
          status2: 'saved'
        }
      } else {
        return item
      }
    })

    popupData.Multiple_Unit = needata
    setData1(needata)
    const payData = {
      restid: parseInt(RestID),
      catId: CatId,
      catName: catName,
      itemId: itemid,
      unit_details: data1
    }
    //   mainAxios
    //   .post('/api/Inventory/addNewUnitToMultipleUnits', payData)
    //   .then(res => {
    //  console.log(res,'res')
    //     if(res.data.status==1||2){
    //       const needata=data1.map((item)=>{
    //         if(item.id==id){
    //           alert('hi')
    //         return {...item,status1:'label'}
    //         }
    //         else{
    //           alert('bye')
    //           return item
    //         }
    //        })
    //        setData1(needata)
    //   }
    //   })
    //   .catch(() => {

    //   })
  }

  const editfunction = () => {
    const payData = {
      restid: RestID,
      catId: details.catId,
      catName: details.catName,
      itemId: details.id,
      unit_details: data1
    }
    mainAxios
      .post('/api/Inventory/addNewUnitToMultipleUnits', payData)
      .then(res => { })
      .catch(() => { })
  }

  const handleCheckboxOnChange = e => {
    let temp = { ...popupData }
    temp['IsInMaster'] = e.target.checked
    setPopupData(temp)
  };

  const editItem = e => {
    let temp = { ...popupData };

    temp['itemName'] = e.item;
    temp['category'] = `${e.category}~${e.catId}`;
    temp['unit'] = e.unit;
    temp['unitPrice'] = parseFloat(e.unitPrice.toString().replace('$', '')).toFixed(2);
    temp['id'] = e.id;
    temp['Multiple_Unit'] = e?.Multiple_Unit;
    temp['subCategory'] = e?.subCategory;
    temp['SubCategoryId'] = e?.SubCategoryId;
    temp['IsInMaster'] = e?.Status == '1' ? true : false;
    temp['Product'] = e?.ProductName ? `${e?.ProductName}~${e?.ProductId}` : "";
    temp['subProduct'] = e?.SubProductName ? `${e?.SubProductName}~${e?.SubProductId}` : "";
    temp['location'] = e?.location || "";
    temp['purveyor'] = e?.Purveyor || "";
    temp['Inventory_date'] = e?.Inventory_date || "";
    temp['pack'] = e?.Pack || "";
    temp['packSize'] = e?.PackSize || "";
    temp['quantity'] = e?.Quantity || "";
    temp['PackPrice'] = e?.PackPrice || (parseFloat(e.unitPrice.toString().replace('$', '')) / (parseFloat(e?.Pack) || 0)).toFixed(2);
    temp['oldCategory'] = e.category;
    temp['oldCat_Id'] = e.catId


    if (subCategoryRawData?.length > 0) {
      const subcat = subCategoryRawData.filter(
        u =>
          u.CatId.toString() === e.catId.toString()
        // && u.CatName.toString().trim() === e.category.toString().trim()
      )

      if (subcat.length > 0) {
        const cat = subcat[0].SubCategories.map(x => ({
          label: x.SubCatName,
          value: `${x.SubCatName}~${x.SubCategoryId}`
        }))
        setSubCategories(cat)
      } else {
        setSubCategories([])
      }
    }

    if (productAndSubProductList.length > 0) {
      let productlist = productAndSubProductList?.find(
        a => a.CatId.toString() === e.catId?.toString()
      );
      SetProductList(productlist?.Products);
      let subProduct = productlist?.Products?.find(
        a => a.ProductId.toString() === e?.ProductId?.toString()
      );
      SetSubProductList(subProduct?.SubProducts);
    }

    setUnitDropDown(prevOptions =>
      prevOptions.filter(option => {
        // Check if option.value is not equal to e.unit
        // and is not present in any of the Multiple_Unit names
        return (
          option.value !== e.unit &&
          !e.Multiple_Unit.some(
            multipleUnit => multipleUnit.Name === option.value
          )
        )
      })
    )

    const Multiple_Unit = e?.Multiple_Unit?.map(item => {
      return { ...item, status1: 'label', status2: 'saved' }
    })
    Multiple_Unit.unshift({
      Name: e.unit,
      Price: e.unitPrice.toString().replace('$', ''),
      Quantity: '',
      index: '',
      status1: '',
      status2: ''
    })

    setData1(Multiple_Unit)
    setPopupData(temp)
    setallowrow(true)
    setBackupPopupData(temp)
    setEditOrCreate('Edit Product')
    showModal(true)
    setCatName(e.category)
    setCatId(e.catId)
    setItemId(e.id)
  };

  const tableProps = {
    onRowSelectionChange: setRowSelection,
    renderTopToolbarCustomActions: ({ table }) => (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
          alignSelf: 'center'
        }}
      >
        <div style={{ display: 'flex', gap: '20px' }}>
          <div>
            <Button className='printButton' icon={<AddIcon />} onClick={() => {
              setPopupData(initialPopupData)
              setBackupPopupData(initialPopupData)
              setEditOrCreate('Add New Product')
              showModal()
              setData1([{}])
              setUnitDropDown(dropDownValue)
              setBackupsaveData([])
              setCounter(0)
            }}>
              <Space>
                Add New Product
              </Space>
            </Button>
          </div>
          <div>
            <Dropdown
              menu={{ items }}
              trigger={['click']}
            >
              <Button className='printDropdown' icon={<FileDownloadRoundedIcon />}>
                <Space>
                  Export Product
                  <DownOutlined />
                </Space>
              </Button>
            </Dropdown>
          </div>
        </div>
      </div>
    )
  };

  const table1 = useMaterialReactTable({
    columns: columns1,
    data: data1,
    enableTopToolbar: false,
    enableColumnResizing: false,
    enablePagination: false,
    enableColumnFilter: false,
    enableColumnFilterModes: false,
    enableColumnMenu: false,
    initialState: { density: 'compact' },
    layoutMode: 'semantic'
  })

  const exportPdfData = (originalData) => {
    const transformedData = originalData.map(category => ({
      CatId: category.CatId,
      CatName: category.CatName,
      subCategory: Object.values(
        category.Items.reduce((subCatMap, item) => {
          let subCategoryId = item?.SubCategoryId || "Others";
          let subCategoryName = item?.SubCatName || "Others";
          let productId = item?.ProductId || "Others";
          let productName = item?.Product || "Others";
          let subProductId = item?.subProductId || "Others";
          let subProductName = item?.SubProduct || "Others";

          // Initialize SubCategory
          if (!subCatMap[subCategoryId]) {
            subCatMap[subCategoryId] = {
              SubCategoryId: subCategoryId,
              SubCatName: subCategoryName,
              product: {}
            };
          }

          // Initialize Product
          if (!subCatMap[subCategoryId].product[productId]) {
            subCatMap[subCategoryId].product[productId] = {
              Product: productName,
              ProductId: productId,
              subProduct: {}
            };
          }

          // Initialize SubProduct
          if (!subCatMap[subCategoryId].product[productId].subProduct[subProductId]) {
            subCatMap[subCategoryId].product[productId].subProduct[subProductId] = {
              SubProduct: subProductName,
              subProductId: subProductId,
              items: []
            };
          }

          // Add Item to SubProduct
          subCatMap[subCategoryId].product[productId].subProduct[subProductId].items.push({
            ...item
          });

          return subCatMap;
        }, {})
      ).map(subCat => ({
        ...subCat,
        product: Object.values(subCat.product).map(product => ({
          ...product,
          subProduct: Object.values(product.subProduct)
        }))
      }))
    })).filter(item => item.subCategory.length > 0);

    setPdfData(transformedData);
  };

  const getData = () => {
    setProgressBar(true)
    setTableView(true)
    let req = {
      "RestId": RestID,
      "Inventorykey": "null",
      "page_status": 1
    }
    mainAxios
      .post('/api/Inventory', req)
      .then(res => {
        setDynamoData(res.data)
        exportPdfData(res.data.Data.InventoryDetails)
        setProgressBar(false)
        res.data.Data.InventoryDetails.length == 0 && setIsModalOpentwo(true)
      })
      .catch(err => {
        setIsLoading(false)
        setDynamoData([])
        setProgressBar(false)
        setNodata(true)
        console.log(err)
      })
  }

  const getdropvalue = () => {
    mainAxios.get('api/Inventory/Getcategories/' + RestID).then(res => {
      const temp = res.data.Categorydetails
      const newCategoryDropDown = temp.map(item => ({
        label: item.Cat_name,
        value: `${item.Cat_name}~${item.Cat_id}`
      }));

      setCategoryDropDown(newCategoryDropDown)
    })
  }

  const handleSearch = e => {
    setSearchedValue(e)
    if (Budget_Exist_Status == 0) {
      setIsModalOpenbudget(true)
    } else {
      if (e !== '' && e !== undefined && e !== null) {
        const filteredData = backupData.filter(x =>
          x.search?.toLocaleLowerCase()?.includes(e?.toLocaleLowerCase())
        )
        setData(filteredData)
      } else {
        setData(backupData)
      }
    }
  }

  const handleMultipleCheckBox = () => {
    const arr = []
    setAddMasterSheetLoader(true)
    for (const key in rowSelection) {
      if (rowSelection.hasOwnProperty(key)) {
        if (rowSelection[key]) {
          let d = key.split('~')
          let json = {
            restid: RestID,
            catId: d[2],
            catName: d[1],
            itemId: d[0],
            status: 1
          }
          arr.push(json)
        }
      }
    }
    console.log(arr)
    mainAxios
      .post('api/Inventory/AddToMasterCountsheet', arr)
      .then(e => {
        setAddMasterSheetLoader(false)
        setRowSelection({})
        getData()
        if (arr.length == 1) {
          toast.success('Selected Item Added to Master Countsheet')
        } else {
          toast.success('Selected Items Added to Master Countsheet')
        }
      })
      .catch(e => {
        setAddMasterSheetLoader(false)
        toast.error('Error while adding selected items to masterCountsheet')
      })
  }

  const getSubCategories = (key) => {
    mainAxios
      .get('api/Inventory/GetSubCategories/' + RestID)
      .then(res => {
        if (res.data?.status == '1') {
          setSubCategoryRawData(res.data.SubCategoryArray);
          if (key === 'new') {
            if (res?.data?.SubCategoryArray?.length > 0) {
              const subcat = res?.data?.SubCategoryArray.filter(
                u =>
                  u.CatId.toString() === popupData.category.split('~')[1].toString()
                // && u.CatName.toString().trim() === popupData.category.split('~')[0].toString().trim()
              )

              if (subcat.length > 0) {
                const cat = subcat[0].SubCategories.map(x => ({
                  label: x.SubCatName,
                  value: `${x.SubCatName}~${x.SubCategoryId}`
                }))
                setSubCategories(cat)
              } else {
                setSubCategories([])
              }
            }
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  const AddNewSubCategory = () => {
    let subcat = {
      restid: parseInt(RestID),
      catId: parseInt(popupData.category.split('~')[1]),
      catName: popupData.category.split('~')[0],
      subCatName: newSubCategoryName.trim()
    }
    mainAxios.post('api/Inventory/addSubCategory', subcat).then(res => {
      if (res.data?.status == 1) {
        toast.success('Sub Category Added Successfully');
        getSubCategories('new');
        setNewSubCategoryName('');
      } else {
        toast.warning(res.data?.msg || 'Failed to add Sub Category');
      }
    }).catch(error => {
      toast.warning('Failed to add Sub Category');
      setNewSubCategoryName('');
    });

  }

  const addNewProductAndSubProduct = (key) => {
    let req = key === "Product" ?
      {
        "restid": RestID,
        "catId": popupData.category.split('~')[1],
        "catName": popupData.category.split('~')[0],
        "Product": newProduct.trim(),
        "ProductId": null,
        "SubProduct": null,
        "subProductId": null
      } : {
        "restid": RestID,
        "catId": popupData.category.split('~')[1],
        "catName": popupData.category.split('~')[0],
        "Product": popupData.Product.split('~')[0],
        "ProductId": popupData.Product.split('~')[1],
        "SubProduct": newSubProduct.trim(),
        "subProductId": null
      };

    mainAxios
      .post(`api/Inventory/addproductSubCategory`, req)
      .then(res => {
        if (res?.data?.status == 1) {
          toast.success(`${key === 'Product' ? 'Product' : 'Common Name'} Added Successfully`);
          getProductlist('new');
          setNewProduct('');
          setNewSubProduct('');
        } else {
          toast.warning(res?.data?.msg || `Failed to add ${key === 'Product' ? 'Product' : 'Common Name'}`);
        }
      })
      .catch(err => {
        console.log(err)
        toast.warning(`Failed to add ${key === 'Product' ? 'Product' : 'Common Name'}`);
      });
  };

  const getProductlist = async (key) => {
    await mainAxios
      .get('api/Inventory/GetProductdetails/' + RestID)
      .then(res => {
        if (res.data?.status === '1') {
          SetProductAndSubProductList(res?.data?.Productdetailsarray);
          if (key === 'new') {
            if (res?.data?.Productdetailsarray.length > 0) {
              let productlist = res?.data?.Productdetailsarray?.find(
                a => a.CatId.toString() === popupData.category.split('~')[1]?.toString()
              );
              SetProductList(productlist?.Products);
              let subProduct = productlist?.Products?.find(
                a => a.ProductId.toString() === popupData.Product.split('~')[1]?.toString()
              );
              SetSubProductList(subProduct?.SubProducts);
            }
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
  };

  const handleInitialization = async () => {
    if (Budget_Exist_Status == 1) {
      await getProductlist('');
      getSubCategories('old');
      getdropvalue();
      getData();
    } else {
      setIsModalOpenbudget(true)
    }
  };

  useEffect(() => {
    handleInitialization();
  }, []);

  useEffect(() => {
    if (dynamoData?.Data) {
      if (
        dynamoData.Data?.InventoryDetails &&
        dynamoData.Data?.InventoryDetails?.length > 0
      ) {
        const temp = []
        const da = dynamoData?.Data?.InventoryDetails.map(cat => {
          temp.push({
            label: cat.CatName,
            value: `${cat.CatName}~${cat.CatId}`
          });

          return cat.Items.map(item => {
            if (item?.Multiple_Unit && item?.Multiple_Unit?.length > 0) {
              let temp = item?.Multiple_Unit?.map(mUnit => {
                return {
                  category: '',
                  subCategory: item?.SubCatName || '',
                  SubCategoryId: item?.SubCategoryId | '',
                  catId: cat?.CatId,
                  item: '',
                  unitPrice: mUnit?.Price || 0,
                  unit: mUnit?.Name || '',
                  multiQnty: mUnit?.Quantity || 0,
                  multiPrice: mUnit?.price || 0,
                  multiName: mUnit?.UnitName || '',
                  id: item?.id,
                  Status: item?.Status || '1',
                  CreatedAt: '',
                  Multiple_Unit: [],
                  search: item?.Name || '',
                  // ProductId: item?.ProductID,
                  ProductId: item?.ProductId || '',
                  ProductName: item?.Product || '',
                  SubProductName: item?.SubProduct || '',
                  SubProductId: item?.subProductId || '',
                  location: item?.location || '',
                  Inventory_date: item?.Inventory_date ? dayjs(item?.Inventory_date).format('MM/DD/YYYY') : '',
                  Purveyor: item?.Purveyor || '',
                  Pack: item?.Pack || '',
                  PackSize: item?.PackSize || '',
                  Quantity: item?.Quantity || '',
                  PackPrice: item?.PackPrice || 0,
                }
              })
              let json = {
                category: cat?.CatName,
                subCategory: item?.SubCatName || '',
                SubCategoryId: item?.SubCategoryId || '',
                catId: cat?.CatId,
                item: item?.Name || '',
                unitPrice: item?.Price || 0,
                unit: item?.Unit || '',
                id: item?.id,
                Status: item?.Status || '1',
                CreatedAt: item?.CreatedAt
                  ? dayjs(item?.CreatedAt).format('MM/DD/YYYY')
                  : '',
                Multiple_Unit: item?.Multiple_Unit ? item?.Multiple_Unit : [],
                search: item?.Name || '',
                ProductId: item?.ProductId || '',
                ProductName: item?.Product || '',
                SubProductName: item?.SubProduct || '',
                SubProductId: item?.subProductId || '',
                location: item?.location || '',
                Inventory_date: item?.Inventory_date ? dayjs(item?.Inventory_date).format('MM/DD/YYYY') : '',
                Purveyor: item?.Purveyor || '',
                Pack: item?.Pack || '',
                PackSize: item?.PackSize || '',
                Quantity: item?.Quantity || '',
                PackPrice: item?.PackPrice || 0,
              }
              // temp.push(json)
              return [json, ...temp]
            } else {
              return {
                category: cat?.CatName,
                subCategory: item?.SubCatName || '',
                SubCategoryId: item?.SubCategoryId || '',
                catId: cat?.CatId,
                item: item?.Name || '',
                unitPrice: item?.Price || 0,
                unit: item?.Unit || '',
                id: item?.id,
                Status: item?.Status || '1',
                CreatedAt: item?.CreatedAt
                  ? dayjs(item?.CreatedAt).format('MM/DD/YYYY')
                  : '',
                Multiple_Unit: item?.Multiple_Unit ? item?.Multiple_Unit : [],
                search: item?.Name || '',
                ProductId: item?.ProductId || '',
                ProductName: item?.Product || '',
                SubProductName: item?.SubProduct || '',
                SubProductId: item?.subProductId || '',
                location: item?.location || '',
                Inventory_date: item?.Inventory_date ? dayjs(item?.Inventory_date).format('MM/DD/YYYY') : '',
                Purveyor: item?.Purveyor || '',
                Pack: item?.Pack || '',
                PackSize: item?.PackSize || '',
                Quantity: item?.Quantity || '',
                PackPrice: item?.PackPrice || 0,
              }
            }
          })
        });
        // setCategoryDropDown(temp)
        let finalData = da.flat().flat();
        finalData.sort((a, b) => {
          // Handle empty strings by treating them as very old dates
          const dateA = a.Inventory_date === "" ? new Date(0) : new Date(a.Inventory_date);
          const dateB = b.Inventory_date === "" ? new Date(0) : new Date(b.Inventory_date);
          return dateB - dateA;
      });
        setData(finalData);
        setIsLoading(false)
        setBackupData(da.flat().flat())
      }
    }
  }, [dynamoData]);

  // useEffect(() => {
  //   searchedValue?.length > 0 && handleSearch(searchedValue)
  // }, [backupData]);

  return (
    <>
      <div className="startinventoryOuter">
        <div className="startinventory">
          <div
            className='overallhistory product-table'
          // style={{ paddingBottom: '25px' }}
          >
            <>
              {' '}
              {Budget_Exist_Status == 0 ? (
                <div
                  className='no-inventory'
                  style={{
                    height: '70vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <img style={{ width: '5em' }} src='/no-item.png' />
                    <h2 style={{ fontSize: '18px' }}>No Items Found</h2>
                  </div>
                </div>
              ) : (
                <div>
                  <div className='ProductsSheetTable'>
                    {nodata ? (
                      <>
                        <div
                          className=''
                          style={{
                            height: '60vh',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                        >
                          <div style={{ textAlign: 'center' }}>
                            <img style={{ width: '5em' }} src='/no-item.png' />
                            <h2 style={{ fontSize: '18px' }}>No Items Found</h2>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className='filterParent'>
                          <div className='filterChild'>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>

                            </div>
                          </div>
                        </div>
                        <div style={{ marginTop: '10px' }} className='no_pinning'>
                          <CustomTable
                            data={data}
                            columns={columns}
                            enableTopToolbar={true}
                            enableColumnResizing={true}
                            enableColumnActions={false}
                            enableRowSelection={false}//{row => row.original.ProductId === "" ? true : false}
                            enablePagination={true}
                            // searchIconVisible={true}
                            enableGlobalFilter={true}
                            enableStickyHeader={true}
                            initialState={{ columnPinning: { right: ['action'], left: ['mrt-row-select'] } }}
                            rowSelection={rowSelection}
                            // getRowId={row => { return `${row?.id}~${row?.category}~${row?.catId}` }}
                            optionalProps={tableProps}
                            isLoading={isLoading}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
            </>
          </div>

          <Modal
            title='Set Up Your Budget'
            open={IsModalOpenbudget}
            footer={[
              <Button
                key='submit'
                onClick={handleOkprodbudget}
                style={{ backgroundColor: '#2BAB47', color: '#fff' }}
              >
                Got It!
              </Button>
            ]}
          >
            <p className='addnewcount1'>
              Please establish a budget to activate the Inventory Feature.
            </p>
          </Modal>

          <Modal
            className='Item-popup'
            // title={}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={null}
            closable={false}
            width={700}
            maskClosable={false}
          >
            <div className='Item-popup-child'>
              <div className='item-modal-header'>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    cursor: 'pointer'
                  }}
                >
                  <p className='item-modal-title'>{editOrCreate}</p>
                  <CancelIcon
                    onClick={handleCancel}
                    style={{ color: '#acacac', fontSize: '20px' }}
                  />
                </div>
              </div>
              <hr />
              <div className='item-modal-body'>
                <div className='col-md-12'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <p className='poptext'>Category</p>
                      <Select
                        style={{
                          width: '100%'
                        }}
                        placeholder='Select'
                        showSearch
                        required
                        value={
                          editOrCreate !== 'Add New Product'
                            ? popupData.category?.split('~')[0]
                            : popupData.category
                        }
                        onChange={e => PopuponChange('category', e)}
                        options={categoryDropdown}
                      // disabled={editOrCreate === 'Edit Product'}
                      />
                      {isError && popupData?.category?.length === 0 && (
                        <p style={{ color: 'red', margin: 0, fontSize: 12 }}>
                          Please Select Valid Category
                        </p>
                      )}
                    </div>
                    <div className='col-md-6'>
                      <p className='poptext'>Sub Category</p>
                      <Select
                        size="medium"
                        showSearch
                        disabled={popupData?.category.length === 0}
                        dropdownRender={(menu) => (
                          <>
                            {menu}
                            <Divider
                              style={{
                                margin: "8px 0",
                              }}
                            />
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <Input
                                size="middle"
                                value={newSubCategoryName}
                                onKeyDown={(e) => e.stopPropagation()}
                                onChange={(e) => { setNewSubCategoryName(e.target.value) }}
                              />
                              <Button htmlType="submit" icon={<PlusOutlined />}
                                disabled={!newSubCategoryName.trim()} onClick={() => { AddNewSubCategory() }}>
                                Add
                              </Button>
                            </div>
                          </>
                        )}
                        options={subCategories}
                        value={popupData.subCategory}
                        onDropdownVisibleChange={(open) => { !open && setNewSubCategoryName('') }}
                        onChange={e => PopuponChange('subCategory', e)}
                      />
                      {isError && (!popupData?.subCategory || popupData?.subCategory?.length === 0) && (
                        <p style={{ color: 'red', margin: 0, fontSize: 12 }}>
                          Please Select Valid SubCategory
                        </p>
                      )}
                    </div>
                  </div>
                  <div className='row' style={{ marginTop: '10px' }}>
                    <div className='col-md-6'>
                      <p className='poptext'>Product</p>
                      <Select
                        size="medium"
                        showSearch
                        disabled={(popupData?.category?.length === 0)}
                        dropdownRender={(menu) => (
                          <>
                            {menu}
                            <Divider
                              style={{
                                margin: "8px 0",
                              }}
                            />
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <Input
                                size="middle"
                                value={newProduct}
                                onKeyDown={(e) => e.stopPropagation()}
                                onChange={(e) => { setNewProduct(e.target.value) }}
                              />
                              <Button htmlType="submit" icon={<PlusOutlined />}
                                disabled={!newProduct.trim()}
                                onClick={() => { addNewProductAndSubProduct('Product') }}>
                                Add
                              </Button>
                            </div>
                          </>
                        )}
                        options={
                          productList?.map(a => (
                            {
                              "label": a?.ProductName,
                              "value": `${a?.ProductName}~${a?.ProductId}`
                            })
                          )
                        }
                        value={
                          editOrCreate !== 'Add New Product'
                            ? popupData.Product?.split('~')[0]
                            : popupData.Product
                        }
                        onDropdownVisibleChange={(open) => { !open && setNewProduct('') }}
                        onChange={e => PopuponChange('Product', e)}
                      />
                      {isError && popupData?.Product?.length === 0 && (
                        <p style={{ color: 'red', margin: 0, fontSize: 12 }}>
                          Please Select Valid Product
                        </p>
                      )}
                      {/* {isError && popupData?.unit?.length === 0 && (
                    <p style={{ color: 'red', margin: 0 }}>
                      Please Select Valid Unit
                    </p>
                  )} */}
                    </div>
                    <div className='col-md-6'>
                      <p className='poptext'>Common Name</p>
                      <Select
                        size="medium"
                        showSearch
                        disabled={!popupData?.Product}
                        dropdownRender={(menu) => (
                          <>
                            {menu}
                            <Divider
                              style={{
                                margin: "8px 0",
                              }}
                            />
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <Input
                                size="middle"
                                value={newSubProduct}
                                onKeyDown={(e) => e.stopPropagation()}
                                onChange={(e) => { setNewSubProduct(e.target.value) }}
                              />
                              <Button htmlType="submit" icon={<PlusOutlined />}
                                disabled={!newSubProduct.trim()}
                                onClick={() => { addNewProductAndSubProduct('SubProduct') }}>
                                Add
                              </Button>
                            </div>
                          </>
                        )}
                        options={subProductList?.map(a => (
                          {
                            "label": a?.SubProductName,
                            "value": `${a?.SubProductName}~${a?.SubProductId}`
                          })
                        )}
                        onDropdownVisibleChange={(open) => { !open && setNewSubProduct('') }}
                        onChange={e => PopuponChange('subProduct', e)}
                        value={
                          editOrCreate !== 'Add New Product'
                            ? popupData.subProduct?.split('~')[0]
                            : popupData.subProduct
                        }
                      />
                      {isError && popupData?.subProduct?.length === 0 && (
                        <p style={{ color: 'red', margin: 0, fontSize: 12 }}>
                          Please Select Valid SubProduct
                        </p>
                      )}
                      {/* {isError && popupData?.unit?.length === 0 && (
                    <p style={{ color: 'red', margin: 0 }}>
                      Please Select Valid Unit
                    </p>
                  )} */}
                    </div>
                  </div>
                  <hr />
                  <div className='row' style={{ marginTop: '10px' }}>
                    <div className='col-md-12'>
                      <p className='poptext'>Item Name</p>
                      <Input
                        value={popupData.itemName}
                        onChange={e => {
                          PopuponChange('itemName', e.target.value)
                          setIsError(false)
                        }}
                      />
                      {isError && popupData?.itemName?.length === 0 && (
                        <p style={{ color: 'red', margin: 0, fontSize: 12 }}>
                          Please Enter Valid Item Name
                        </p>
                      )}
                      {isError &&
                        isItemExist &&
                        popupData?.itemName?.length > 0 && (
                          <p style={{ color: 'red', fontSize: 12, margin: 0 }}>Item Name Already Exists</p>
                        )}
                    </div>
                  </div>
                  <div style={{ marginTop: '10px', display: 'flex', gap: 10 }}>
                    {/* <div style={{ flex: 1 }}>
                      <p className='poptext'>Quantity</p>
                      <Input
                        value={popupData.quantity}
                        onChange={e => {
                          PopuponChange('quantity', e.target.value)
                          setIsError(false)
                        }}
                      />
                      {isError && popupData?.quantity?.length === 0 && (
                        <p style={{ color: 'red', margin: 0, fontSize: 12 }}>
                          Please Enter Valid Quantity
                        </p>
                      )}
                    </div> */}
                    <div style={{ flex: 1 }}>
                      <p className='poptext'>Unit</p>
                      <Select
                        placeholder='Select'
                        showSearch
                        required
                        value={
                          editOrCreate !== 'Add New Product'
                            ? popupData.unit
                            : popupData.unit
                        }
                        onChange={e => PopuponChange('unit', e)}
                        options={dropDownValue}
                      />
                      {isError && popupData?.unit?.length === 0 && (
                        <p style={{ color: 'red', margin: 0, fontSize: 12 }}>
                          Please Select Valid Unit
                        </p>
                      )}
                    </div>
                    <div style={{ flex: 1 }}>
                      <p className='poptext'>Price / Unit</p>
                      <div className='customInputOuter'>
                        <NumericFormat
                          className='customInput'
                          name='unitPrice'
                          value={popupData.unitPrice?.toString().replace('$', '')}
                          onKeyDown={handleKeyDown}
                          onValueChange={e => PopuponChange('unitPrice', e.value)}
                          onBlur={e => {
                            e.target.value?.length === 0 &&
                              popupData.unitPrice.toString().replace('$', '')
                                ?.length === 0
                              ? formatUnitPrice('0')
                              : formatUnitPrice(
                                popupData.unitPrice.toString().replace('$', '')
                              )
                          }}
                        />
                      </div>
                      {isError &&
                        popupData?.unitPrice?.toLocaleString()?.length === 0 && (
                          <p style={{ color: 'red', fontSize: 12, margin: 0 }}>
                            Please Enter Valid Unit Price
                          </p>
                        )}
                    </div>
                  </div>
                  <div style={{ marginTop: '10px', display: 'flex', gap: 10 }}>
                    <div style={{ flex: 1 }}>
                      <p className='poptext'>Pack</p>
                      <NumericFormat
                        value={popupData.pack}
                        className='customInput'
                        style={{ width: '100%' }}
                        onValueChange={e => {
                          PopuponChange('pack', e.value)
                          setIsError(false)
                        }}
                      />
                      {/* {isError && popupData?.pack?.length === 0 && (
                        <p style={{ color: 'red', margin: 0, fontSize: 12 }}>
                          Please Enter Pack Value
                        </p>
                      )} */}
                    </div>
                    <div style={{ flex: 1 }}>
                      <p className='poptext'>Size / Pack</p>
                      <Input
                        value={popupData.packSize}
                        onChange={e => {
                          PopuponChange('packSize', e.target.value)
                          setIsError(false)
                        }}
                      />
                      {/* {isError && popupData?.packSize?.length === 0 && (
                        <p style={{ color: 'red', margin: 0, fontSize: 12 }}>
                          Please Enter Pack Size
                        </p>
                      )} */}
                    </div>
                    <div style={{ flex: 1 }}>
                      <p className='poptext'>Price / Pack</p>
                      <div className='customInputOuter'>
                        <NumericFormat
                          className='customInput'
                          name='PackPrice'
                          value={popupData.PackPrice?.toString().replace('$', '')}
                          onKeyDown={handleKeyDown}
                          disabled
                          onValueChange={e => PopuponChange('PackPrice', e.value)}
                          onBlur={e => {
                            e.target.value?.length === 0 &&
                              popupData.PackPrice.toString().replace('$', '')
                                ?.length === 0
                              ? formatPackPrice('0')
                              : formatPackPrice(
                                popupData.PackPrice.toString().replace('$', '')
                              )
                          }}
                        />
                      </div>
                      {/* {isError &&
                        popupData?.PackPrice?.toLocaleString()?.length === 0 && (
                          <p style={{ color: 'red', fontSize: 12, margin: 0 }}>
                            Please Enter Valid Pack Price
                          </p>
                        )} */}
                    </div>
                    <div style={{ flex: 1 }}>
                      <p className='poptext'>Location</p>
                      <Input
                        value={popupData.location}
                        onChange={e => {
                          PopuponChange('location', e.target.value)
                          setIsError(false)
                        }}
                      />
                      {/* {isError && popupData?.itemName?.length === 0 && (
                    <p style={{ color: 'red', margin: 0 }}>
                      Please Enter Valid Item Name
                    </p>
                  )}
                  {isError &&
                    isItemExist &&
                    popupData?.itemName?.length > 0 && (
                      <p style={{ color: 'red' }}>Item Name Already Exists</p>
                    )} */}
                    </div>
                  </div>
                  {/* <div className='row' style={{ marginTop: '2px' }}>
                    <div className='col-md-12'>
                      <div
                        style={{ display: 'flex', gap: '128px', marginTop: '5px' }}
                      >
                        <Button
                          className='unit-btn'
                          type='text'
                          style={{ color: '#19A73F', fontSize: '14px' }}
                          onClick={addnewRow}
                          disabled={popupData.unit == ''}
                          icon={<PlusCircleFilled style={{ cursor: 'pointer' }} />}
                        >
                          Add Inventory Units
                        </Button>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className='row' style={{ marginTop: '10px' }}>
                    {editOrCreate === 'Add New Product' && (
                      <>
                        <div
                          style={{
                            padding: '0',
                            marginTop: '-10px',
                            display: 'flex'
                          }}
                        >
                          <Checkbox
                            onChange={handleCheckboxOnChange}
                            checked={popupData?.IsInMaster}
                          >
                            {popupData?.IsInMaster
                              ? 'Remove From Master CountSheet'
                              : 'Add Item to Master Sheet'}
                          </Checkbox>
                          <span style={{ marginTop: '8px' }}>
                            Add Item to Master Sheet
                          </span>
                        </div>
                      </>
                    )}
                  </div> */}
                  {/* <div className='row' style={{ marginTop: '10px' }}>
                    <div className='col-md-12'>
                      {allowrow && (
                        <div className='table-div'>
                          <MaterialReactTable table={table1} />
                        </div>
                      )}
                    </div>
                  </div> */}
                </div>
              </div>
              <hr />
              <div className='item-modal-footer'>
                <div
                  className='drawer-btn'
                  style={{ display: 'flex', gap: '10px', justifyContent: 'end' }}
                >
                  <Button
                    className='Deactivate-Button'
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    key='submit'
                    style={{ backgroundColor: '#2BAB47', color: '#fff' }}
                    disabled={isClicked}
                    onClick={() => { handleOk() }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            className='delete-popup'
            title='Create Sub-category'
            open={isModalOpencategory}
            onOk={handleOkcategory}
            onCancel={handleCancelcategory}
            maskClosable={false}
            footer={[
              <div
                className='drawer-btn'
                style={{ display: 'flex', gap: '10px', justifyContent: 'end' }}
              >
                <Button
                  className='Deactivate-Button'
                  onClick={handleCancelcategory}
                >
                  Cancel
                </Button>
                <Button
                  disabled={newSubCategoryName?.toString()?.trim().length === 0}
                  onClick={AddNewSubCategory}
                  key='submit'
                  style={{ backgroundColor: '#2BAB47', color: '#fff' }}
                >
                  Save
                </Button>
              </div>
            ]}
          >
            <Input
              disabled={popupData?.category.length === 0}
              value={newSubCategoryName}
              placeholder='Enter Sub-category'
              onChange={e => {
                setNewSubCategoryName(e.target.value)
              }}
              style={{ width: '90%', margin: '0 auto', display: 'block' }}
            />
          </Modal>

          <Modal
            className='delete-popup'
            title='Delete Item'
            open={isModalOpendelete}
            onOk={handleOkdelete}
            onCancel={handleCanceldelete}
            maskClosable={false}
            footer={[
              <div
                className='drawer-btn'
                style={{ display: 'flex', gap: '10px', justifyContent: 'end' }}
              >
                <Button
                  className='Deactivate-Button'
                  onClick={handleCanceldelete}
                >
                  Cancel
                </Button>
                <Button
                  key='submit'
                  style={{ backgroundColor: '#2BAB47', color: '#fff' }}
                  onClick={handleOkdelete}
                >
                  Confirm
                </Button>
              </div>
            ]}
          >
            <p className='addnewcount1'>Confirm deletion of the item?</p>
          </Modal>

          <Modal
            className='delete-popup1'
            title={stsText[1]}
            open={isModalOpenstatus}
            onOk={handleOkstatus}
            onCancel={handleCancelstatus}
            maskClosable={false}
            footer={[
              <div
                className='drawer-btn'
                style={{ display: 'flex', gap: '10px', justifyContent: 'end' }}
              >
                <Button
                  className='Deactivate-Button'
                  onClick={handleCancelstatus}
                >
                  Cancel
                </Button>
                <Button
                  key='submit'
                  style={{ backgroundColor: '#2BAB47', color: '#fff' }}
                  onClick={handleOkstatus}
                >
                  Confirm
                </Button>
              </div>
            ]}
          >
            <p className='addnewcount1'>{stsText[0]}</p>
          </Modal>

          <Modal
            className='GroupingPopUp'
            title="Grouping"
            open={false}
            // onOk={handleOkstatus}
            // onCancel={handleCancelstatus}
            maskClosable={false}
            footer={[
              <div
                className='drawer-btn'
                style={{ display: 'flex', gap: '10px', justifyContent: 'end' }}
              >
                <Button
                  className='Deactivate-Button'
                // onClick={}
                >
                  Cancel
                </Button>
                <Button
                  key='submit'
                  style={{ backgroundColor: '#2BAB47', color: '#fff' }}
                // onClick={}
                >
                  Add
                </Button>
              </div>
            ]}
          >
            <div >
              <div className='col-md-12'>
                <div className='row' style={{ marginTop: '5px' }}>
                  <div className='col-md-6'>
                    <p className='poptext'>Product</p>
                    <Select
                      size="medium"
                      showSearch
                      // disabled={popupData?.category.length === 0}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider
                            style={{
                              margin: "8px 0",
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <Input
                              size="middle"
                              value={newProduct}
                              onKeyDown={(e) => e.stopPropagation()}
                              onChange={(e) => { setNewProduct(e.target.value) }}
                            />
                            <Button htmlType="submit" icon={<PlusOutlined />}
                              onClick={() => { addNewProductAndSubProduct('Product') }}>
                              Add
                            </Button>
                          </div>
                        </>
                      )}
                      options={
                        productList?.map(a => (
                          {
                            "label": a?.ProductName,
                            "value": `${a?.ProductName}~${a?.ProductId}`
                          })
                        )
                      }
                      value={
                        editOrCreate !== 'Add New Product'
                          ? popupData.Product?.split('~')[0]
                          : popupData.Product
                      }
                      onDropdownVisibleChange={(open) => { !open && setNewProduct('') }}
                      onChange={e => PopuponChange('Product', e)}
                    />
                    {/* {isError && popupData?.unit?.length === 0 && (
                    <p style={{ color: 'red', margin: 0 }}>
                      Please Select Valid Unit
                    </p>
                  )} */}
                  </div>
                  <div className='col-md-6'>
                    <p className='poptext'>Common Name</p>
                    <Select
                      size="medium"
                      showSearch
                      disabled={!popupData?.Product}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider
                            style={{
                              margin: "8px 0",
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <Input
                              size="middle"
                              value={newSubProduct}
                              onKeyDown={(e) => e.stopPropagation()}
                              onChange={(e) => { setNewSubProduct(e.target.value) }}
                            />
                            <Button htmlType="submit" icon={<PlusOutlined />}
                              onClick={() => { addNewProductAndSubProduct('SubProduct') }}>
                              Add
                            </Button>
                          </div>
                        </>
                      )}
                      options={subProductList?.map(a => (
                        {
                          "label": a?.SubProductName,
                          "value": `${a?.SubProductName}~${a?.SubProductId}`
                        })
                      )}
                      onDropdownVisibleChange={(open) => { !open && setNewSubProduct('') }}
                      onChange={e => PopuponChange('subProduct', e)}
                      value={
                        editOrCreate !== 'Add New Product'
                          ? popupData.subProduct?.split('~')[0]
                          : popupData.subProduct
                      }
                    />
                    {/* {isError && popupData?.unit?.length === 0 && (
                    <p style={{ color: 'red', margin: 0 }}>
                      Please Select Valid Unit
                    </p>
                  )} */}
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            title='Add Inventory Products'
            open={IsModalOpentwo}
            onOk={handleOkprod}
            onCancel={handleCancelprod}
            maskClosable={false}
            footer={[
              <Button
                key='submit'
                onClick={handleOkprod}
                style={{ backgroundColor: '#2BAB47', color: '#fff' }}
              >
                Got It!
              </Button>
            ]}
          >
            <p className='addnewcount1'>
              Consider uploading recent invoices to assist in setting up your
              inventory.
            </p>
          </Modal>

          <div
            style={{
              position: 'absolute',
              left: '-5000px',
              top: '-5000px',
              overflow: 'hidden',
              width: '0',
              height: '0'
            }}
          >
            <PrintProductTemplate ref={pdfRef} productData={PdfData} />
          </div>
        </div>
      </div>
    </>
  )
}

export default Products
